import { connect } from 'react-redux';
import ScribeKeypressHandler from './ScribeKeypressHandler';

import {
  dispatchSpeakerChangeMutation,
  enterInsertSpeakerNameMode,
  enterUpdateAudioSourceMode,
  exitInsertSpeakerNameMode,
  exitUpdateAudioSourceMode,
  insertSpeakerName,
  mergeTranscript,
  scribeCreateTranscript,
  scribeDeselectTranscriptWord,
  scribeEnterSearchMode,
  updateSpeakerListened,
  scribeSelectTranscriptWord,
  splitTranscript,
} from '../../actions';

const mapStateToProps = ({
  scribeConversation: {
    conversationRequested,
    conversationStarted,
    status,
    transcriptsCurrent,
    ui: { selectedTranscriptIndex, selectedWordIndex, selectedWordInputValue, selectionLength },
  },
  scribeTranscriptUI: { mutationTriggers, insertSpeakerNameMode, updateAudioSourceMode },
}) => ({
  conversationRequested,
  conversationStarted,
  insertSpeakerNameMode,
  mutationTriggers,
  selectedTranscriptIndex,
  selectedWordIndex,
  selectedWordInputValue,
  selectionLength,
  status,
  transcriptsCurrent,
  updateAudioSourceMode,
});

export default connect(mapStateToProps, {
  dispatchSpeakerChangeMutation,
  enterInsertSpeakerNameMode,
  exitInsertSpeakerNameMode,
  insertSpeakerName,
  enterUpdateAudioSourceMode,
  exitUpdateAudioSourceMode,
  mergeTranscript,
  scribeCreateTranscript,
  scribeDeselectTranscriptWord,
  scribeEnterSearchMode,
  scribeSelectTranscriptWord,
  splitTranscript,
  updateSpeakerListened,
})(ScribeKeypressHandler);
